export default angular.module("mars.vet.dnareports.controller.breed",[]).controller('BreedController',
    function($rootScope, $scope, $routeParams, $window, BreedListService, EntryService, ImageService, NavigationService, TranslationService, EntryIDService, reportdata) {
      var sampleDetails = reportdata.sampleDetails;

        EntryService.getEntry($routeParams.entryId).then(
            function(response) {
                $scope.translation = TranslationService.getTranslation;
                $scope.breedName = response.fields.breedName;
                $scope.breedData = response.fields.breedData;
                $scope.description = $scope.breedData['History'];
                $scope.appDescription = $scope.breedData['Variation description'];
                $scope.breedTitle = $scope.breedData['WisdomMX Name'];
                $scope.descriptionArray = [];
                $scope.traitsArray = [];
                $scope.breedExtName = $scope.breedData['Shorter Name'];
                $scope.height = $scope.breedData['Height'];
                $scope.heightAverage = $scope.breedData['Height Average'];
                $scope.weightPet = $scope.breedData['Weight Observed'];
                $scope.weightShow = $scope.breedData['Weight']
                var breedList = BreedListService.getBreedList();
                $scope.count = breedList[$scope.breedName];
                $scope.percentageValue = ($scope.count * 100) / 8;
                $rootScope.pageTitle = $scope.breedData['Shorter Name'] + ' - ' + $scope.percentageValue + '%';
                $scope.title = $scope.breedData['Shorter Name'] + ' - ' + $scope.percentageValue + '%';
                var traitTitle = "Recognize any of these [BREED NAME] behaviors in [DOG NAME]?";
                $scope.traitTitle = traitTitle.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName).replaceAll("[BREED NAME]", response.fields.breedName);

                NavigationService.setNavigationUrls();

                for (var k = 1; k <= 4; k++) {
                    $scope.traitsArray.push($scope.breedData['Trait ' + k]);
                }

                angular.forEach($scope.description.split("\n"), function(value, key) {
                    if (value != '') {
                        $scope.descriptionArray.push(value);
                    }
                });

                $scope.breedCarousel = [];

                $scope.carouselImageList = response.fields.breedCarousel['CarouselImages'];
                if ($scope.carouselImageList != '') {
                    $scope.qArr = $scope.carouselImageList.split(",");

                    for (var k = 0; k < $scope.qArr.length; k++) {
                        ImageService.getImageUrl($scope.qArr[k]).then(function(response) {
                            $scope.breedCarousel.push(response.data.fields.file.url);
                        });
                    }
                }
                ImageService.getImageUrl($scope.breedData['Large JPG Name']).then(function(response) {
                    $scope.breedImg = response.data.fields.file.url;
                });
                ImageService.getImageUrl($scope.breedData['Tail']).then(function(response) {
                    $scope.breedTail = response.data.fields.file.url;
                });
                ImageService.getImageUrl($scope.breedData['Muzzle']).then(function(response) {
                    $scope.breedMuzzle = response.data.fields.file.url;
                });
                ImageService.getImageUrl($scope.breedData['Ear']).then(function(response) {
                    $scope.breedEar = response.data.fields.file.url;
                });
                ImageService.getImageUrl($scope.breedData['Scaled Name']).then(function(response) {
                    $scope.breedAppearance = response.data.fields.file.url;
                });

                $window.ga('send', 'pageview', {
                    'page': 'BreedProfile'
                });
            });


    }).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/breed.controller.js